import dayjs from "dayjs";
import "dayjs/locale/tr";

export const maskPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return phoneNumber;
  let cleaned = phoneNumber.replace(/\D/g, "");

  if (cleaned.startsWith("90")) {
    cleaned = cleaned.substring(2);
  }

  const match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    return `+90 (${match[1]}) ${match[2]} ${match[3]} ${match[4]}`;
  }
  return phoneNumber;
};

// Jitsi oda adını backend kuralına uydurur: boşluk -> tire, geçersiz karakterleri atar.
// Backend: /^[a-zA-Z0-9\-_]*$/ , MaxLength(100)
export const sanitizeJitsiRoomName = (value: string): string =>
  value
    .replace(/\s+/g, "-") // boşluk(lar) -> tek tire
    .replace(/[^a-zA-Z0-9\-_]/g, "") // izinli set dışındaki her karakteri at
    .slice(0, 100); // backend max uzunluk

export const formatDateRange = (startDate: string, endDate: string) => {
  if (!startDate || !endDate) return "-";

  const start = dayjs(startDate).locale("tr").format("DD.MM.YYYY");
  const end = dayjs(endDate).locale("tr").format("DD.MM.YYYY");

  return `${start} - ${end}`;
};

export const formatDate = (date: string, format = "DD.MM.YYYY") => {
  if (!date) return "-";
  return dayjs(date).locale("tr").format(format);
};

export { formatDateLong } from "./date";

export * from "./auth";
export * from "./cookies";
export * from "./textStyle";
